<script lang="ts" setup>
import { AppNavigationItemProps } from './_types';

const props = defineProps<AppNavigationItemProps>();

const route = useRoute();
const isActiveRoute = computed(() => route.name?.toString().startsWith(props.nav.to.name?.toString() ?? ''));
const canShow = computed(() => props.nav.can == null || props.nav.can());
const filteredChildren = computed(() => props.nav.children?.filter((x) => x.can == null || x.can()) ?? []);
</script>

<template>
    <template v-if="canShow && nav.custom">
        <notification-status v-if="navKey === 'notifications'" />
    </template>
    <app-header-navigation-hover-btn v-else-if="canShow && filteredChildren.length" :label="$t(nav.title)">
        <q-list dense style="min-width: 100px">
            <q-item
                v-for="chNav in filteredChildren"
                :key="chNav.title"
                clickable
                active-class="text-bold text-primary"
                :to="chNav.to"
            >
                <q-item-section>
                    {{ $t(chNav.title) }}
                </q-item-section>
            </q-item>
        </q-list>
    </app-header-navigation-hover-btn>
    <flat-btn
        v-else-if="canShow && nav.icon"
        :icon="nav.icon"
        size="1.6rem"
        :text-color="isActiveRoute ? 'secondary' : 'primary'"
        :active-color="!isActiveRoute ? 'secondary' : 'primary'"
        :to="nav.to"
        dense
    />
    <flat-btn
        v-else-if="canShow"
        :label="$t(nav.title)"
        dense
        class="nav-header-item q-mr-md"
        :class="{
            'nav-header-item--active': isActiveRoute,
        }"
        text-color="primary"
        active-color="primary"
        :to="nav.to"
    />
</template>

<style lang="scss">
.nav-header-item {
    font-weight: normal;

    &:hover {
        text-decoration: underline;
        text-underline-offset: 12px;
    }

    &.nav-header-item--active {
        font-weight: bold;
        text-decoration: underline;
        text-underline-offset: 12px;
    }
}
</style>
